import { render, staticRenderFns } from "./personalInformation.vue?vue&type=template&id=2ab7aaed&scoped=true&lang=pug"
import script from "./personalInformation.vue?vue&type=script&lang=ts"
export * from "./personalInformation.vue?vue&type=script&lang=ts"
import style0 from "./personalInformation.vue?vue&type=style&index=0&id=2ab7aaed&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab7aaed",
  null
  
)

export default component.exports